const initialState = {
    contents: [],
};

const shipping = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_CHECKOUT_SHIPPING':
            return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default shipping;
